// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"78956263cb2634284872","339":"18e89839c4257ed9f1ae"}[chunkId] + ".js";
};